'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _ChevronLeft = require('wix-ui-icons-common/ChevronLeft');

var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackLink = function BackLink(_ref) {
  var onBackHandler = _ref.onBackHandler,
      children = _ref.children;
  return _react2.default.createElement(
    'a',
    { className: _styles2.default.backLink, onClick: onBackHandler, 'data-hook': 'menu-navigation-back-link' },
    _react2.default.createElement(
      'span',
      { className: _styles2.default.backArrow },
      _react2.default.createElement(_ChevronLeft2.default, null)
    ),
    _react2.default.createElement(
      'span',
      { className: _styles2.default.backLabel },
      children
    )
  );
};

BackLink.propTypes = {
  onBackHandler: _propTypes.func,
  children: _propTypes.node
};

exports.default = BackLink;